import Vue from 'vue'
import Vuelidate from 'vuelidate'
import Notifications from 'vue-notification'
import App from './App.vue'
import router from './router.js'
import store from './store'
// import './setup/registerServiceWorker.js'
import './setup/registerGlobalComponents.js'
import './setup/amplify.js'
import observeAuth from './setup/amplifyAuth.js'

Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(Notifications)
const eventBus = new Vue()
Vue.prototype.$bus = eventBus
Vue.prototype.$alert = msg => eventBus.$emit('alert', msg)
Vue.prototype.$notifySuccess = msg => Vue.prototype.$notify({ title: msg, type: 'success' })
Vue.prototype.$notifyError = msg => Vue.prototype.$notify({ title: msg, type: 'error' })

observeAuth(store, router)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
